export const FEATURE_FLAG_KEY = {
  CT: 'CT',
  CTI: 'CTI',
  TL: 'TL',
  TLI: 'TLI',
  PN: 'PN',
}

export const isTL_CT_IO = [
  FEATURE_FLAG_KEY.CT,
  FEATURE_FLAG_KEY.TL,
].includes(process.env.REACT_APP_FEATURE_FLAG_KEY);


export const isIO = [
  FEATURE_FLAG_KEY.CT,
  FEATURE_FLAG_KEY.PN,
  FEATURE_FLAG_KEY.TL,
].includes(process.env.REACT_APP_FEATURE_FLAG_KEY);

export const isPN = [
  FEATURE_FLAG_KEY.PN,
].includes(process.env.REACT_APP_FEATURE_FLAG_KEY);